import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TextBody } from '@blocket/blocket-ui'
import ResponsiveHeader from '../ResponsiveHeader'

const CancelButtonWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
`

const CancelButton = styled(TextBody)`
  &:hover {
    cursor: pointer;
  }
  &:active {
    opacity: 0.75;
  }
  user-select: none;
`

class Header extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <ResponsiveHeader>
        <CancelButtonWrapper>
          <CancelButton onClick={this.props.cancelBtnEvent}>
            {this.props.cancelBtnText}
          </CancelButton>
        </CancelButtonWrapper>
      </ResponsiveHeader>
    )
  }
}

Header.propTypes = {
  cancelBtnEvent: PropTypes.func.isRequired,
  cancelBtnText: PropTypes.string.isRequired,
}

export default Header
